const Loader = () => {
    return (
        <div class="flex flex-row gap-2" style={{
            height: '60vh', display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
          <div class="w-4 h-4 rounded-full bg-[#ff5028] animate-bounce"></div>
            <div class="w-4 h-4 rounded-full bg-[#ff5028] animate-bounce [animation-delay:-.3s]"></div>
            <div class="w-4 h-4 rounded-full bg-[#ff5028] animate-bounce [animation-delay:-.5s]"></div>
        </div>
    )
}

export default Loader